import type { UpdateSparkActivityPayload } from '../../types/spark-activity';
import MobileFrame from './MobileFrame';
import PreviewHeader from './PreviewHeader';
import PreviewFooter from './PreviewFooter';
import ActivityPreviewContent from './ActivityPreviewContent';
import { STAGE_COLORS } from './constants';

interface ActivityPreviewPanelProps {
  formData: UpdateSparkActivityPayload | null;
  focusedStage: number | null;
  onStageChange: (index: number | null) => void;
}

export default function ActivityPreviewPanel({ formData, focusedStage, onStageChange }: ActivityPreviewPanelProps) {
  const stageIndex = focusedStage ?? 0;
  const stage = formData?.stages[stageIndex];

  return (
    <div className="flex flex-col items-center gap-4">
      <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-pine-ink-soft self-start">
        Preview
      </p>
      <MobileFrame>
        <div className="h-full flex flex-col relative">
          <PreviewHeader />
          <div className="flex-1 overflow-y-auto">
            {formData ? (
              <ActivityPreviewContent
                title={formData.title}
                prep={formData.prep}
                duration={formData.duration}
                durationMax={formData.durationMax}
                description={stage?.description ?? ''}
                steps={stage?.points ?? []}
                whyItWorks={stage?.whyItWorks ?? ''}
                expertTips={stage?.expertTips ?? ''}
              />
            ) : (
              <div className="flex items-center justify-center h-full">
                <p className="text-[12px]" style={{ color: '#A9B7BE' }}>Select an activity</p>
              </div>
            )}
          </div>
          <PreviewFooter />
        </div>
      </MobileFrame>

      {/* Stage switcher */}
      <div className="flex flex-col items-center gap-2">
        <p className="text-[10px] text-pine-ink-soft">
          Stage: <span className="font-semibold">{STAGE_COLORS[stageIndex]?.label}</span>
        </p>
        <div className="flex gap-1">
          {STAGE_COLORS.map((stage, i) => (
            <button
              key={i}
              onClick={() => onStageChange(i)}
              className="w-8 h-8 rounded-full text-xs font-bold flex items-center justify-center transition-all"
              style={{
                backgroundColor: stage.bg,
                color: stage.text,
                outline: stageIndex === i ? '2px solid #01A7C8' : 'none',
                outlineOffset: '2px',
              }}
            >
              {stage.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
